import React, { useEffect,useRef } from "react";
import "./App.css";
import "./resources/sass/manage-jobposting.scss";
import Home from "./components/Home";
import { RecruiterDetailsResponse, RTKErrorType } from "./types";
import { getUserDetails } from "./utils/getUserDetails";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../node_modules/@foundit/header/dist/HeaderWeb.css"
import HeaderLayout from "./HeaderLayout";
import { useDispatch } from "react-redux";
import { setIsLoginSuccess } from "./redux/reducers/loginSlice";
import { useLazyTrackHealthQuery } from "./redux/apis/manageJobPostingHooks";
import { getHealthApiPayload } from "./utils/helpers";

function App() {
  const [userDetails, setUserDetails] = React.useState<RecruiterDetailsResponse | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [error,setError] = React.useState(false)
 
  // Function to fetch user details from sessionStorage
  const fetchUserDetails = () => {
    const details = getUserDetails();
    if (details && Object.keys(details).length > 0) {
      
      setUserDetails(details);
      setIsLoading(false);
    }
  };
 
  useEffect(() => {
    if (!userDetails) {
      const intervalId = setInterval(() => {
        fetchUserDetails();
      }, 100);
 
      return () => clearInterval(intervalId);
    }
  }, [userDetails]);

  const startTime = useRef(new Date());
  const hasTriggered = useRef(false);

  const [trigger] = useLazyTrackHealthQuery();
  const dispatch = useDispatch()
  // * Not required, as redirection is handled on basequerywithauth
  useEffect(() => {
    if (
      (!window.location.origin.includes("localhost")) &&
      error 
    ) {
      sessionStorage.setItem("prevUrl", window.location.href);
      window.location.href = `${window.location.origin}`;
    }
  }, [error]);

  useEffect(() => {
    if ((userDetails || error) && !hasTriggered.current) {
      let status = userDetails ? 200 : 400;
      let queryObject = {}
      const healthPayload = getHealthApiPayload(
        status,
        queryObject,
        startTime.current,
        userDetails?.recruiter_id,
        "MJP"
      );
      hasTriggered.current = true;
      trigger(healthPayload);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails, error]);


  useEffect(()=>{
    if(userDetails){
      dispatch(setIsLoginSuccess(true));
    }
  },[userDetails]);

  return (
    <>
    <HeaderLayout/>
    <div className="App">
      <Home />
      <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="colored"
        />
    </div>
    </>
  );

}

export default App;
